import { render, staticRenderFns } from "./UsageQuota.vue?vue&type=template&id=572a5679&scoped=true"
import script from "./UsageQuota.vue?vue&type=script&lang=js"
export * from "./UsageQuota.vue?vue&type=script&lang=js"
import style0 from "./UsageQuota.vue?vue&type=style&index=0&id=572a5679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a5679",
  null
  
)

export default component.exports